"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ValidationError extends Error {
    constructor(message, fieldName, errorCode) {
        super(message);
        this.fieldName = fieldName;
        this.errorCode = errorCode;
        this.name = 'ValidationError';
    }
}
exports.default = ValidationError;
//# sourceMappingURL=ValidationError.js.map